import { PanelState, PanelStatus } from './types';

export const resetPanelState = (): PanelState => {
  return { isOpen: false, status: PanelStatus.Inactive };
};

export const activePanelState = (): PanelState => {
  return { isOpen: true, status: PanelStatus.Active };
};

export const completePanelState = (): PanelState => {
  return { isOpen: false, status: PanelStatus.Completed };
};

export const revisitPanelState = (): PanelState => {
  return { isOpen: true, status: PanelStatus.Completed };
};
